var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardholdersScreen } from '../../../typings';
import { translate } from '../../../strings/i18n';
import { Footer, FooterWrapper } from '../../../modal/content/subcomponents';
import triggerManageCardHoldersAnalytics from '../../../helpers/trigger-manage-card-holders-analytics';
import triggerManageCardHoldersSamsAnalytics from '../../../helpers/trigger-manage-card-holders-sams-analytics';
import { PAGE_NAME, SAMS_PAGE_NAME } from '../../../const/analytics';
var CardHoldersFooter = function (_a) {
    var _b;
    var changeScreen = _a.changeScreen, currentScreen = _a.currentScreen, handleAddAuthUserSubmit = _a.handleAddAuthUserSubmit, handleClose = _a.handleClose, usersLimit = _a.usersLimit, _c = _a.isSamsClient, isSamsClient = _c === void 0 ? false : _c;
    var backToAccountServicesText = translate('button.backToAccountServices');
    var addAuthorizedUserText = translate('button.addAuthorizedUser');
    var addAsAnAuthorizedUserText = translate('addAuthUserScreen.addAsAnAuthorizedUser');
    var DATA_PRIMARY_TYPE = 'add authorized user';
    var DATA_SECONDARY_TYPE = 'back to account services';
    var DATA_PRIMARY_MCH_TYPE = 'back to manage cardholders';
    var DATA_OBJECT = 'button';
    var addAuthUsersAllowed = {
        handlePrimaryButton: function () {
            if (isSamsClient) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SELECTION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER_SAMS_LIST });
            }
            else {
                triggerManageCardHoldersAnalytics({
                    pageName: PAGE_NAME.ADDITION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER });
            }
        },
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_PRIMARY_TYPE,
        primaryText: addAuthorizedUserText,
        handleSecondaryButton: handleClose,
        dataSecondaryObject: DATA_OBJECT,
        dataSecondaryType: DATA_SECONDARY_TYPE,
        secondaryButtonType: 'ghost',
        secondaryText: backToAccountServicesText
    };
    var backToAccountServicesPrimary = {
        primaryText: backToAccountServicesText,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_SECONDARY_TYPE,
        handlePrimaryButton: handleClose
    };
    var backToManageCardholdersPrimary = {
        primaryText: translate('button.backToManageCardholders'),
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_PRIMARY_MCH_TYPE,
        handlePrimaryButton: function () {
            changeScreen({ screen: CardholdersScreen.INITIAL_SCREEN });
        }
    };
    var addAuthUsersFooter = (_b = {},
        _b[CardholdersScreen.INITIAL_SCREEN] = usersLimit === '0' ? backToAccountServicesPrimary : addAuthUsersAllowed,
        _b[CardholdersScreen.ACCESS_DENIED_SCREEN] = backToAccountServicesPrimary,
        _b[CardholdersScreen.ADD_AUTH_USER] = __assign(__assign({}, addAuthUsersAllowed), { handlePrimaryButton: function () {
                if (handleAddAuthUserSubmit) {
                    handleAddAuthUserSubmit();
                }
                else {
                    triggerManageCardHoldersSamsAnalytics({
                        pageName: SAMS_PAGE_NAME.ADD_DOB
                    });
                    changeScreen({
                        screen: CardholdersScreen.ADD_AUTH_USER
                    });
                }
            }, secondaryText: translate('button.cancel'), handleSecondaryButton: function () {
                return changeScreen({ screen: CardholdersScreen.INITIAL_SCREEN });
            }, dataSecondaryType: 'cancel' }),
        _b[CardholdersScreen.ADD_AUTH_USER_SAMS] = __assign(__assign({}, addAuthUsersAllowed), { handlePrimaryButton: function () {
                if (handleAddAuthUserSubmit) {
                    handleAddAuthUserSubmit();
                }
                else {
                    triggerManageCardHoldersSamsAnalytics({
                        pageName: SAMS_PAGE_NAME.ADD_DOB
                    });
                    changeScreen({
                        screen: CardholdersScreen.ADD_AUTH_USER_SAMS
                    });
                }
            }, secondaryText: translate('button.cancel'), handleSecondaryButton: function () {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SELECTION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER_SAMS_LIST });
            }, dataSecondaryType: 'cancel' }),
        _b[CardholdersScreen.ERROR_SCREEN] = backToAccountServicesPrimary,
        _b[CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER] = backToManageCardholdersPrimary,
        _b[CardholdersScreen.CONFIRMATION_SCREEN_EXISTING_USER] = addAuthUsersAllowed,
        _b[CardholdersScreen.VERIFY_USER_SCREEN] = backToAccountServicesPrimary,
        _b[CardholdersScreen.ADD_AUTH_USER_SAMS_LIST] = __assign(__assign({}, addAuthUsersAllowed), { handlePrimaryButton: function () {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.ADD_DOB
                });
                changeScreen({
                    screen: CardholdersScreen.ADD_AUTH_USER_SAMS
                });
            }, primaryText: addAsAnAuthorizedUserText, dataPrimaryType: 'add as an authorized user' }),
        _b);
    return (_jsx(FooterWrapper, { children: _jsx(Footer, __assign({ "data-testid": "cardholders-footer" }, addAuthUsersFooter[currentScreen])) }));
};
export default CardHoldersFooter;
